import { get } from './http'

// // 登录页面api
// export let login = (p) => post('/aaa', p) //登录
// export let getCode = (p) => get('/bbb', p) //登录

// 获取微信配置
export const getWxConfig = (params) =>
  get(`/api/wx/signJsConfig?url=${params.url}&appId=${params.appId}`)
